<template>
<div class='entry'>
  <slot></slot>
  <div v-if="data === null" class='loading'>{{pk}} <img src="/files/imgs/loading.svg" /></div>
  <div v-else>
    <transition name="slide-down">
    <div v-if="condensed" class='condensed_container'>
      <div style='display: flex; align-items: center'>
	<div style='padding-right: 20px'><span v-if="!isNaN(idx)">{{idx+1}}.</span> {{ moment(entry.date).format('L') }}
	</div>
	<slot name="condensed"></slot>
      </div>
      <table class='tabular condensed_table' cellpadding="0">
	<tr v-for="(li, idx) in entry.acc_line_items" class='condensed_acc_line_items_tr'>
          <td>{{ get_prop("name", li.account_id, data.accounts) }}</td>
	  <td></td>
          <td>{{li.name}}</td>
          <td style='text-align: right'>
	    {{fmt(li.amount, li.currency)}}
	  </td>
	</tr>
	<tr v-for='(li, idx) in entry.cat_line_items'>
          <td>{{ get_prop("name", li.category_id, data.categories) }}</td>
          <td>{{ get_prop("name", li.klass_id, data.klasses) }}</td>
          <td>{{li.name}}</td>
          <td style='white-space: nowrap; text-align: right'>
	    {{ fmt(li.amount, li.currency) }}
          </td>
	</tr>
      </table>
    </div>
    <form v-else @submit.prevent="save">
      <div style='display: flex'>
	<div><span :title="data.id" v-if="!isNaN(idx)">{{idx+1}}.</span>
	  <div v-if="can_edit" style="display: inline-block; max-width: 125px">
	    <date-picker v-model="entry.date" />
	  </div>
	  <span v-else>{{ moment(entry.date).format("L") }}</span>
	</div>
	<div>Type: {{types_lu[data.type]}} | 
	  Status: {{status_lu[data.status]}} <button v-if="can_edit && data.status===4" type="button" @click="mark_completed()">Mark Completed</button></div>
	<div style='flex-grow: 1; margin-left: 5px'></div>
	<div>Company/Individual: {{ data.company !== null && data.company !== undefined ? data.company.name : '' }}
	  <!--<editable :value="data.company !== null ? data.company_id : null" :choices='company_choices' :initial='data.company' show_null />-->
	</div>
	<div style='flex-grow: 1; margin-left: 5px'></div>
	<div>
          Owner:
	  <editable :value='data.owner !== null ? data.owner_id : null' :choices='data.user_choices' @input='set_owner($event)' show_null />
	</div>
      </div>
      <table class='tabular mobile-table' cellpadding="0">
	<tr class='tr_header mobile-hide'>
          <th>
            <div v-if="can_edit" title='Add Line Item' class='icon small' @click="add_acc_line_item()">
              <img src="../assets/icons/add.svg" />
            </div>
	    Account
	  </th>
          <th>Doc #</th>
          <th>Description</th>
          <th>Amount</th>
	</tr>
	<tr v-for="(li, idx) in entry.acc_line_items" :key="li.id" class='acc_line_item'>
          <td class='mobile-flex col1 row1'>
            <div v-if="can_edit" class='icon small' @click='delete_acc_line_item(idx)' title='Delete Line Item'><img src="../assets/icons/delete.svg" /></div>
	    <div v-if="can_edit" class='icon small' @click='find_match_(li.id, li.account_id, li.amount, li.currency)' title="Search For Matching Entry"><img src="../assets/icons/filter.svg" /></div>
	    <div class='icon small' @click='li.expanded = !li.expanded' title='Expand Line Item'><img :src="li.expanded ? '/files/backend/icons/carrot-down.svg' : '/files/backend/icons/carrot-right.svg'" /></div>
	    <accounts v-if='can_edit' v-model='li.account_id' required :types="data.account_types" :items="data.accounts" />
	    <span v-else>{{ get_prop("name", li.account_id, data.accounts) }}</span>
            <div title="Reconciled" class='clickable' @click="set_reconciled(li.id, !li.reconciled)" style="display: inline-block; width: 25px; margin-left: 10px; height: 1.25em; border: 1px solid #888; text-align: center"> {{li.reconciled ? 'X' : '&nbsp;'}}</div>
	    <table v-if="li.expanded" width="100%" :key="li.id">
              <tr>
	        <th>Post Date:</th>
                <td>
                  <date-picker v-if="can_edit" style="display: inline-block" v-model="li.bankdate" />
	          <span v-else>{{ moment(li.bankdate).format("L") }}</span><br />
                </td>
              </tr>
              <tr>
	        <th>Transaction Id:</th>
                <td>
	          <input v-if="can_edit" v-model="li.trans_id" style="width: 100%" />
	          <span v-else>{{ li.trans_id }}</span><br />
                </td>
              </tr>
              <tr>
	        <th>Related Entity:</th>
                <td>
		  <select v-if="can_edit" v-model="li.related_entity_id" >
		    <option :value="null">---</option>
		    <option v-for="entity in data.entities" :value="entity.id" :key='entity.id'>{{entity.name}}</option>
		  </select>
	          <span v-else>{{ data.entities.by[li.related_entity_id].name  }}</span><br />
                </td>
              </tr>
	      <tr>
		<th title="Only one line item can be the payment record. Used for outgoing checks.">Payment Record:</th>
		<td><input v-if='li.id !== null' type='checkbox' :checked='entry.payment_id !== null && li.id===entry.payment_id' @change='setPaymentId(li, $event.target.checked)' /><span v-else> Line Item Not Saved. Save to assign.</span></td>
	      </tr>
	    </table>
	  </td>
          <td class='col2 row1'>
	    <div class='mobile-show title'>Doc #:</div>
	    <input v-if='can_edit' type='text' v-model='li.doc_num' />
	    <span v-else>{{li.doc_num}}</span>
	  </td>
          <td class='col3 row1'>
	    <div class='mobile-show title'>Desc:</div>
	    <input v-if='can_edit' required type='text' v-model='li.name' /> 
	    <span v-else>{{li.name}}</span>
	  </td>
          <td class='col4 row1' style='text-align: right'>
	    <div class='mobile-show title'>Amount:</div>
	    <span  v-if='can_edit' style='white-space: nowrap'>
	      <input :value="amt(li.amount, li.currency)" type='number' :step="li.currency==='USD' || li.currency==='CAD' ? '0.01' : '1'" required @keyup.enter="$event.target.blur()" @blur="li.amount=to_amt($event.target.value, li.currency)" style='text-align: right; width: 100px'  />
	      {{li.currency}}
	    </span>
	    <span v-else>{{fmt(li.amount, li.currency)}}</span>
	  </td>
	</tr>
	<div v-if="can_edit" title='Add Line Item' class='icon small mobile-show add-icon' @click="add_acc_line_item()">
          <img src="../assets/icons/add.svg" />
	</div>
	<tr class='tr_header mobile-hide'>
          <th>
            <div style='display: inline-block' title='Add Line Item' class='icon small' @click="add_cat_line_item()">
              <img src="../assets/icons/add.svg" />
            </div>
	    Category
	  </th>
          <th>Classification</th>
          <th></th>
          <th></th>
	</tr>
	<tr v-for='(li, idx) in entry.cat_line_items' class='cat_line_item'>
          <td class='col1 row2'>
            <div class='icon small' @click='delete_cat_line_item(idx)' title='Delete Line Item'><img src="../assets/icons/delete.svg" /></div>
            <accounts required v-model='li.category_id' :items="data.categories" :divisions="data.divisions" :types="data.category_types" />
          </td>
          <td class='col2 row2'>
	    <div class='mobile-show title'>Class:</div>
	    <accounts required v-model='li.klass_id' :items="data.klasses" :divisions="data.divisions" />
          </td>
          <td class='col3 row2'>
	    <div class='mobile-show title'>Desc:</div>
            <input placeholder="Description" required maxlength="256" type='text' v-model='li.name' />
          </td>
          <td class='col4 row2' style='white-space: nowrap; text-align: right'>
	    <div class='mobile-show title'>Amount:</div>
            <input required @keyup.enter="$event.target.blur()" @blur="li.amount=to_amt($event.target.value, li.currency)" style='text-align: right; width: 100px' type='number' :value='amt(li.amount, li.currency)' :step="li.currency==='USD' || li.currency==='CAD' ? '0.01' : '1'"  /> {{ li.currency }}
          </td>
	</tr>
	<tr class='cat-line-extra'>
          <td colspan='100%'>
            <div style='display: flex'>
	      <div title='Add Line Item' class='icon small mobile-show' @click="add_cat_line_item()">
		<img src="../assets/icons/add.svg" />
	      </div>
              <div style='flex-grow:1'></div>
              <p v-if='err_total'>
		Total amount must add to {{fmt(acc_total, currency)}}. Amount outstanding: {{ fmt(err_total, currency) }}
              </p>
            </div>
          </td>
	</tr>
      </table>
      <div>Notes:
	<textarea placeholder="Internal Notes (optional)" style='display: block; width: 100%' v-model='entry.notes'></textarea>
      </div>
      <p class='actions'>
	<img v-if="busy_saving" style='width: 16px' src="/files/imgs/loading.svg" />
	<span v-else>
          <button type='submit' v-if='err_total === 0 && dirty'>Save</button>&nbsp;
          <button type='button' v-if="dirty" @click="reset()">Reset</button>&nbsp;
          <span v-if="data.approved_by">
            Approved By: {{data.approved_by.first_name }} {{data.approved_by.last_name }}
            <button v-if='can_approve && !dirty' type='button'  @click="approve(false)">Unapprove</button>
          </span>&nbsp;
          <button v-else-if='can_approve && !dirty && data.owner !== null' type='button'  @click="approve(true)">Approve</button>&nbsp;
          <button type='button' v-if="can_edit" @click="delete_()">Delete</button>&nbsp;
          <button type='button' v-if="can_edit" @click="void_()">Void</button>&nbsp;
          <button type='button' v-if="can_edit" @click="copy_()">Copy</button>&nbsp;
          <button type='button' v-if="cancelable" @click="$emit('cancel')">{{ canceltext !== null ? canceltext : 'Cancel' }}</button>&nbsp;
	</span>
      </p>
      <div class='find_match' v-if="find_match_visible">
	<h3>Search Fields</h3>
	<table>
	  <tr>
	    <td>ID</td>
	    <td><input type='text' v-model="find_match_data.ali_id" /></td>
	  </tr>
	  <tr>
	    <td>Account</td>
	    <td><accounts v-if='can_edit' v-model='find_match_data.account_id' required :types="data.account_types" :items="data.accounts" /></td>
	  </tr>
	  <tr>
	    <td>Doc #</td>
	    <td><input type='text' v-model="find_match_data.doc_num" /></td>
	  </tr>
	  <tr>
	    <td>Trans Id</td>
	    <td><input type='text' v-model="find_match_data.trans_id" /></td>
	  </tr>
	  <tr>
	    <td>Amount</td>
	    <td>
              <input text="number" v-model="find_match_data.amount" />
	    </td>
	  </tr>
	</table>
	<button type='button' @click="find_match_search_()">Search</button>
	<h3>Search Results</h3>
	<div v-if="find_match_alis.length === 0">
	  No Results
	</div>
	<table v-else>
	  <tr>
	    <th>ID</th>
	    <th>Bank Date</th>
	    <th>Account</th>
	    <th>Rec</th>
	    <th>Doc #</th>
	    <th>Description</th>
	    <th>Amount</th>
	    <th>Actions1</th>
	  </tr>
	  <tr v-for="ali in find_match_alis">
	    <td>{{ali.id}}</td>
	    <td>{{ali.bankdate}}</td>
	    <td>{{data.accounts.find(e => e.id===ali.account_id).full}}</td>
	    <td>{{ali.reconciled ? 'X' : ''}}</td>
	    <td :title="ali.trans_id">{{ali.doc_num}}</td>
	    <td>{{ali.name}}</td>
	    <td class='td_num'>{{amt(ali.amount, ali.currency)}} {{ali.currency}}</td>
	    <td>
	      <button v-if="!ali.reconciled" type="button" @click="match_as_check(ali.id)">Match Paid Check</button>
	      <button type='button' @click='merge_entries(ali.entry_id)'>Merge Entries</button>
	    </td>
	  </tr>
	</table>
      </div>
    </form>
    </transition>
  </div>
  <entry v-if="copy" :initstate="copystate" :pk="-1" :idx="idx+1"></entry>
</div>
</template>

<script>
import Editable from '@/components/Editable.vue'
import Accounts from '@/components/Accounts.vue'
import Entry from '@/components/Entry.vue'
import DatePicker from '@/components/DatePicker.vue'

export default {
    name: "entry",
    components : {
	Editable, Accounts, Entry, DatePicker
    },
    props: {pk: Number,
            idx: Number,
            show_approve: Boolean,
	    condensed: Boolean,
	    cancelable: Boolean,
	    canceltext: String,
	    default_currency: String,
	    initstate : String,
           },
    data: function() { return {
	data: null,
	entry: {
	    id: 0,
	    date: null,
	    cat_line_items: [],
	    acc_line_items: [],
	    memo : '',
	    notes: '',
	},
	busy_saving: false,
	currency: "USD",
	initialized: false,
	copy: false,
	copystate: null,
	find_match_ali_id0: false,
	find_match_visible: false,
	find_match_data : {
	    exclude_id : "",
	    ali_id     : "",
	    account_id : null,
	    doc_num    : "",
	    amount     : null,
	    trans_id   : "",
	    currency   : "",
	},
	find_match_alis: [],
	types_lu: {
	    0 : "Manual Entry",
	    1 : "Online Purchase",
	    2 : "POS Purchase",
	    3 : "Incoming Invoice",
	    4 : "Outgoing Check",
	    5 : "Imported",
	},
	status_lu: {
	    0 : "Completed",
	    1 : "Incoming Needs Paid",
	    2 : "Incoming Received",
	    3 : "Outgoing Needs Printed",
	    4 : "Outgoing Sent",
	},
    }},
    computed: {
        dirty: function() {
            if(this.data === null) return true;
            if(this.data.notes != this.entry.notes) return true
            if(this.data.memo != this.entry.memo) return true
            if(this.data.date != this.entry.date) return true
            if(this.data.acc_line_items.length != this.entry.acc_line_items.length) return true
            if(this.data.cat_line_items.length != this.entry.cat_line_items.length) return true
            if(this.data.payment_id != this.entry.payment_id) return true
            for(var idx in this.data.acc_line_items) {
                var y = this.data.acc_line_items[idx]
                var x = this.entry.acc_line_items[idx]
                if(x.amount     != y.amount    ) return true
                if(x.name       != y.name      ) return true
                if(x.doc_num    != y.doc_num   ) return true
                if(x.id         != y.id        ) return true
                if(x.trans_id   != y.trans_id  ) return true
                if(x.bankdate   != y.bankdate  ) return true
                if(y.account===null || x.account_id != y.account_id) return true
                if(x.related_entity_id != y.related_entity_id) return true
            }
            for(var idx in this.data.cat_line_items) {
                var y = this.data.cat_line_items[idx]
                var x = this.entry.cat_line_items[idx]
                if(x.amount     != y.amount     ) return true
                if(x.name       != y.name       ) return true
                if(x.id         != y.id         ) return true
                if(x.category_id!= y.category_id) return true
                if(x.klass_id   != y.klass_id    ) return true
            }
            return false
        },
	can_edit : function() {
	    return this.$store.getters.entity.perms['BooksEdit']
	},
	can_approve: function() {
	    var divisions = []
	    for(var idx in this.entry.cat_line_items) {
		var cli = this.entry.cat_line_items[idx]
		var division_id = this.get_prop("division_id", cli.klass_id, this.data.klasses)
		if(division_id) {
		    divisions.push(division_id)
		}
		var division_id = this.get_prop("division_id", cli.category_id, this.data.categories)
	    }
	    if(divisions.length === 0) {
		return this.data.approvals.find(a=>a === null) !== undefined
	    } else {
		if(divisions.filter(x => this.data.approvals.includes(x)).length > 0) {
                    return true
		} else {
		    return false
		}
	    }
	},
	acc_total: function() {
	    var total = 0
	    for(var k in this.entry.acc_line_items) {
		var li = this.entry.acc_line_items[k]
		this.currency = li.currency
		total += li.amount
	    }
	    return total
	},
	cat_total: function() {
	    var total = 0
	    for(var k in this.entry.cat_line_items) {
		var li = this.entry.cat_line_items[k]
		total += li.amount
	    }
	    return total
	},
	err_total: function() {
	    return this.acc_total - this.cat_total
	}
    },
    methods: {
	mark_completed: function() {
	    var self=this
	    self.rpc("books","Entry","mark_completed", {id:self.data.id}, "Updating...")
		.then(function(state) {
                    self.data.status = state.status
		})
		.catch(function(error) {
		    self.$store.commit("showError",error)
		})
	    
	},
        set_reconciled: function(id, state) {
            var self=this
            self.busy_saving=true
	    self.rpc("books","Entry","reconcile", {id:self.data.id, account_line_item_id:id, state:state}, "__bg__")
		.then(function(state) {
                    self.busy_saving=false
                    self.entry.acc_line_items.find(ali => ali.id==id).reconciled=state
                    self.$emit('reconciled', {ali:id, state:state})
		})
		.catch(function(error) {
		    self.busy_saving=false
		    self.$store.commit("showError",error)
		})
        },
	setPaymentId: function(li, value) {
	    if(value) {
		//this.entry.payment_id = li.id
		this.$set(this.entry, "payment_id", li.id)
		//this.$set(li, "id", li.id)
	    } else {
		//this.entry.payment_id = null
		this.$set(this.entry, "payment_id", null)
		//this.$set(li, "id", li.id)
	    }
	    this.$forceUpdate()
	},
        save: function() {
	    var self=this
	    self.busy_saving=true
	    self.rpc("books","Entry","save", {entry: self.entry}, "__bg__")
		.then(function(data) {
		    self.busy_saving=false
		    self.set_data(data)
		})
		.catch(function(error) {
		    self.busy_saving=false
		    self.$store.commit("showError",error)
		})
	},
	to_amt: function(amt, currency) {
            return this.$store.getters.amt_to_raw(amt, currency)
	},
	amt: function(amt, currency) {
            return this.$store.getters.raw_to_amt(amt, currency)
	},
	fmt: function(amt, currency) {
            return this.$store.getters.fmt_from_raw(amt, currency)
	},
	add_acc_line_item: function() {
	    this.entry.acc_line_items.push({id:null, name:'', account_id: null, amount:-this.err_total, currency:this.currency, trans_id:"", doc_num:"", reconciled:false, bankdate: this.moment(new Date()).format("YYYY-MM-DD"), related_entity_id:null, expanded:false })
	},
	delete_acc_line_item: function(idx) {
	    this.entry.acc_line_items.splice(idx, 1)
	},
	add_cat_line_item: function() {
	    this.entry.cat_line_items.push({id:null, name:'', category_id: null, klass_id: null, amount:this.err_total, currency:this.currency})
	},
	delete_cat_line_item: function(idx) {
	    this.entry.cat_line_items.splice(idx, 1)
	},
	set_data: function(data) {
	    var self=this
	    for(var k in data.acc_line_items) {
		self.currency = data.acc_line_items[k].currency
		break
	    }
	    data.date = self.moment(data.date).toDate()
	    self.data = data
	    self.data.user_choices = []
	    for(var k in self.data.users) {
		var user = self.data.users[k]
		self.data.user_choices.push({id:user.id, name: user.last_name + ", " + user.first_name })
	    }
	    self.reset()
	    self.$emit("loaded",data)
	    if(self.initialized) {
		self.$emit("saved", data)
	    }
	    self.initialized = true
	},
	set_owner: function(owner_id) {
	    var self=this
	    if(!confirm("Do you want to assign this entry to a new owner?")) {
		return
	    }
	    self.rpc("books","Entry","set_owner", { id: self.data.id, owner_id: owner_id }, "Setting New Owner")
		.then(function(owner_id) {
		    self.data.owner.id=owner_id
		    self.$emit('owner', owner_id)
		})
		.catch(function(error) {
		    self.$store.commit('showError', error)
		})
	    
	},
	reset_find_match: function() {
	    this.find_match_ali_id0 = false
	    this.find_match_visible = false
	    this.find_match_data.ali_id = ""
	    this.find_match_data.account_id = null
	    this.find_match_data.doc_num    = ""
	    this.find_match_data.amount     = null
	    this.find_match_data.currency   = ""
	    this.find_match_alis= []
	},
	reset: function() {
	    this.entry.id = this.data.id
	    this.entry.memo = this.data.memo
	    this.entry.notes = this.data.notes
	    this.entry.date  = this.data.date
	    this.entry.cat_line_items = []
	    this.entry.payment_id = this.data.payment_id
	    for(var k in this.data.cat_line_items) {
		var li = this.data.cat_line_items[k]
		this.entry.cat_line_items.push({
		    id: li.id,
		    category_id: li.category_id,
		    klass_id: li.klass_id,
		    name:  li.name,
		    amount: li.amount,
		    currency: li.currency,
		})
	    }
	    this.entry.acc_line_items = []
	    for(var k in this.data.acc_line_items) {
		var li = this.data.acc_line_items[k]
		//li.bankdate = this.moment(li.bankdate).toDate()
		this.entry.acc_line_items.push({
		    id: li.id,
		    account_id: li.account_id,
		    account   : Object.assign({}, li.account),
		    doc_num   : li.doc_num,
		    amount    : li.amount,
		    currency  : li.currency,
		    name      : li.name,
		    reconciled: li.reconciled,
		    bankdate  : li.bankdate, //this.moment(li.bankdate).toDate(),
		    trans_id  : li.trans_id,
		    related_entity_id : li.related_entity_id,
		    expanded  : false,
		})
	    }
	},
        approve: function(status) {
            var self=this
            self.rpc("books","Entry","approve",{id:self.data.id, status:status},status ? "Marking as Approved" : "Unapproving")
                .then(function(user) {
                    self.data.approved_by = user
                    self.$emit("approved", user)
                })
                .catch(function(error) {
                    self.$store.commit("showError", error)
                })
        },
	get_prop: function(prop, id, objs) {
	    var x = objs.find(k => k.id == id)
	    if (x === undefined) {
		return ""
	    } else {
		return x[prop]
	    }
	},
	find_match_: function(ali_id, account_id, amount, currency) {
	    this.find_match_data.account_id=account_id	    
	    this.find_match_data.amount=this.amt(amount, currency)
	    this.find_match_data.currency=currency
	    this.find_match_ali_id0 = ali_id
	    this.find_match_visible=true
	},
	find_match_search_: function() {
            var self=this
	    self.find_match_data.exclude_id = self.pk
            self.rpc("books","Entry","search_alis", self.find_match_data, "Searching...")
                .then(function(results) {
                    self.find_match_alis = results["alis"]
                })
                .catch(function(error) {
                    self.$store.commit("showError", error)
                })
	},
	merge_entries: function(entry_id) {
            var self=this
	    if(!confirm("This will merge these transactions. It cannot be undone. Are you sure you want to continue?")) {
		return
	    }
            self.rpc("books","Entry","merge_entries", {entry_id0: self.data.id, entry_id1: entry_id}, "Merging...")
                .then(function(data) {
		    self.set_data(data)
		    self.reset_find_match()
                })
                .catch(function(error) {
                    self.$store.commit("showError", error)
                })
	},
	match_as_check: function(ali_id) {
            var self=this
	    if(!confirm("This will copy the transaction info over and delete the original. It cannot be undone. Are you sure you want to continue?")) {
		return
	    }
            self.rpc("books","Entry","match_as_check", {ali_id0: self.find_match_ali_id0, ali_id1: ali_id}, "Matching...")
                .then(function(results) {
		    self.set_data(results)
		    self.reset_find_match()
                })
                .catch(function(error) {
                    self.$store.commit("showError", error)
                })
	},
	copy_ : function() {
	    let x = JSON.parse(JSON.stringify(this.data))
	    x.id = null
	    x.acc_line_items = JSON.parse(JSON.stringify(this.entry.acc_line_items))
	    x.cat_line_items = JSON.parse(JSON.stringify(this.entry.cat_line_items))
	    for(let ali of x.acc_line_items) {
		ali.id = null
		ali.entry_id = null
		ali.trans_id = ""
		ali.reconciled = false
	    }
	    for(let cli of x.cat_line_items) {
		cli.id = null
		cli.entry_id = null
	    }
	    this.copystate = JSON.stringify(x)
	    this.copy = true
	},
        void_: function() {
            var self=this
            if(!confirm('Add notes regarding the reason for voiding this entry. Voiding an entry with a date prior to the closing date will fail when you try to save it and must be done by manually creating a journal entry with a date after the closing date.')) {
                return
            }
	    console.log(self.entry)
	    debugger
	    let tmpAcc = []
	    self.entry.payment_id = null
	    for(let ali of self.entry.acc_line_items) {
		let ali2 = Object.assign({}, ali)
		ali2.id        = null;
		ali2.name      = "VOIDED #" + ali.doc_num + ": " + ali2.name
		ali2.amount    = -ali.amount
		ali2.trans_id  = ""
		ali2.doc_num   = ""
		ali2.reconciled= false
		ali2.expanded  = false
		ali.expanded   = false
		tmpAcc.push(ali2)
	    }
	    for(let ali of tmpAcc) {
		self.entry.acc_line_items.push(ali)
	    }
	    let tmpCat = []
	    for(let cli of self.entry.cat_line_items) {
		let cli2 = Object.assign({}, cli)
		cli2.id        = null;
		cli2.name      = "VOIDED: " + cli2.name
		cli2.amount    = -cli.amount
		tmpCat.push(cli2)
	    }
	    for(let cli of tmpCat) {
		self.entry.cat_line_items.push(cli)
	    }
	},
        delete_: function() {
            var self=this
            if(!confirm('Are you sure you want to delete this entry? It cannot be undone.')) {
                return
            }
            self.rpc("books","Entry","delete",{id:self.data.id},"Deleting")
                .then(function() {
                    self.$emit("delete")
                })
                .catch(function(error) {
                    self.$store.commit("showError", error)
                })
        },
    },
    mounted: function() {
	if(this.default_currency) {
	    this.currency = this.default_currency
	}
        var self=this
	if(this.initstate !== null && this.initstate !== undefined) {
	    let x = JSON.parse(this.initstate)
	    let alis = x.acc_line_items
	    let clis = x.cat_line_items
	    x.acc_line_items = []
	    x.cat_line_items = []
	    this.set_data(x)
	    this.entry.acc_line_items = alis
	    this.entry.cat_line_items = clis
	    
	} else {
            self.rpc("books","Entry","get", {id: self.pk}, "__bg__")
		.then(function(data) {
                    self.set_data(data)
		})
		.catch(function(error) {
                    self.$store.commit('showError', error)
		})
	}
    }
}

</script>

<style scoped>

.loading {
    text-align: center;
}
.loading img {
    height: 16px;
}
.entry {
    box-shadow: 0 0 10px rgba(0,0,0,0.25);
    padding: 20px;
    margin: 5px 5px 40px 5px;
    border: 1px solid #888;
}
.tr_header {
    background-color: #ddd;
}
.tabular {
    width: 100%
}
td, th {
    padding: 3px;
    white-space: nowrap;
}
th {
    text-align: left;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
.condensed_acc_line_items_tr {
    background-color: #ddd;
}
.condensed_container {
    overflow-x: auto;
    padding: 0 1%;
}
.mobile-show {
    display: none;
}
.col1.row1 select, .col2 select {
    width: 20vw;
}
.col1.row2 select {
    width: calc(20vw + 60px);
}
@media screen and (max-width: 800px) {
    .entry {
	padding: 20px 0;
    }
    .mobile-show {
	display: unset;
	white-space: nowrap;
	padding-right: 10px;
    }
    .mobile-show.title {
        flex-basis: 70px;
        flex-grow: 0;
        flex-shrink: 0;
        overflow: hidden;
        text-align: left;
    }
    .mobile-table, .mobile-table tr, .mobile-table th {
	display: block;
	position: relative;
    }
    .mobile-table tr {
	padding: 20px;
    }
    .mobile-hide {
	display: none !important;
    }
    .mobile-table td {
	display: flex;
	align-items: center;
	padding: 5px 0;
    }
    .acc_line_item {
	border-top: 1px solid #888;
	padding: 10px 0;
	background-color: #ddd;
    }
    .cat_line_item {
	border-bottom: 1px solid #888;
	padding: 10px 0;
    }
    .add-icon {
	display: inline-block;
	background-color: #ddd;
    }
    .cat-line-extra {
	padding: 0 !important;
    }
    .col1.row1 select, .col2 select {
	width: 100%;
    }
    .col1.row2 select {
	width: 100%;
    }
}

.slide-down-enter {
    max-height: 0;
    overflow: hidden;
}
.slide-down-enter-active {
    transition: max-height 0.25s;
    overflow: hidden;
}
.slide-down-enter-to {
    max-height: 500px;
    overflow: hidden;
}

.slide-down-leave {
    max-height: 500px;
    overflow: hidden;
}
.slide-down-leave-active {
    transition: max-height 0.75s;
    overflow: hidden;
}
.slide-down-leave-to {
    max-height: 0;
    overflow: hidden;}

</style>
